// Raghu 12/23/2022 3031689933 Table settings popup enhancements
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import {Typography} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {Droppable, Draggable} from 'react-beautiful-dnd';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: '15px',
    margin: 0,
    borderRadius: 8,
  },
  chip: {
    'margin': '4px',
    'color': '#000',
    'fontFamily': 'articulat-cf, sans-serif !important',
    'fontWeight': '500',
    '& .MuiChip-label': {
      fontSize: '11px',
      fontWeight: '500',
      margin: '8px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      // font-size: '13px',
      paddingLeft: '12px',
      paddingRight: '12px',
      textOverflow: 'ellipsis',
    },
  },
  headings: {
    width: '100%',
    color: '#000',
    fontSize: '14px !important',
    fontWeight: '600',
    fontFamily: 'articulat-cf, sans-serif !important',
  },
  closeButton: {
    'color': '#000',
    'width': 20,
    'height': 20,
    'padding': 2,
    'borderRadius': '50%',
    'margin': '0px 5px 0px 0px',
    'backgroundColor': '#FFFFFF',
    '&:hover, &:focus, &.active': {
      backgroundColor: '#FFFFFF',
      color: '#000',
      outline: 'none',
    },
  },
  chipsContainer: {
    border: '2px dashed #b6b6b6',
    borderRadius: '3px',
  },
}));

const ColoumnChips = ({chipData, handleDelete}) => {
  const classes = useStyles();

  // const handleDelete = (chipToDelete) => () => {
  //   setChipData((chips) =>
  //     chips.filter((chip) => chip.key !== chipToDelete.key)
  //   );
  // };

  return (
    <Paper component="div" className={classes.root}>
      <Typography className={`${classes.headings} mb-2`} component="h2">
        Selected Columns
      </Typography>
      {chipData.columnOrder
        .filter((data) => data === 'column-2')
        .map((columnId, ind) => {
          const column = chipData.columns[columnId];
          const tasks = column.taskIds.map((taskId) => chipData.tasks[taskId]);
          return (
            <Droppable key={column.id} droppableId={column.id} direction='horizontal'>
              {(provided) => (
                <div
                  className={`${classes.chipsContainer} row m-0 p-2`}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {tasks.map((task, index) => (
                    <Draggable key={task.id} draggableId={task.id} index={index}>
                      {(provided) => (
                        <div
                          key={task.id}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Chip
                            label={task.content}
                            className={classes.chip}
                            deleteIcon={<CloseIcon className={classes.closeButton} />}
                            style={{ cursor: 'grab' }}
                            onDelete={() => handleDelete(task, index)}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          );
        })}
      {/* Additional code */}
    </Paper>
  );
  
};

export default ColoumnChips;
